/**
 * Компонента выбора индивидуала.
 * Для выбора индивидуала необходимо :
 * 1. Получение rdfType, которому должны соответствовать индивидуал
 * 2. Отображение диалога с выбором свойства и ввода данных этого свойтсв
 * 3. Вызов метода добавления свойства
 */
import React from 'react';
import { Form, Icon, Input, Select, Checkbox, Row, Col, message } from 'antd';
import Label from '../widgets/Label';
import { LoadingComponent } from '../../utils/ui'
import { AdmsAsset } from '../../redux';


const formItemLayout = {
  labelCol  : { xs: { span: 24 }, sm: { span: 6 }, },
  wrapperCol: { xs: { span: 24 }, sm: { span: 18 }, },
};

const { Option } = Select;


/** Форма выбора индивидуала. Обязательно указать IRI выбранного ииндивидуала.
 * Для указания IRI можно либо ввести IRI либо выбрать из списка
 */
class SelectIndividualForm extends React.Component {

  state = {
    loaded: false,                      //Флаг загрузки, списка элементов
    EP:"2022",
    IRI: "http://www.w3.org/ns/adms#",
    predicat: "http://www.w3.org/2002/07/owl#NamedIndividual"
  };

  static getDerivedStateFromProps(props, state) {
    //console.log("SelectIndividual.js static getDerivedStateFromProps(props, state)", props, state);
    if ((state.IRI !=props.IRI )||(state.predicat != props.predicat) || !props.IRI){
      return {loaded: false};
    }
    return null; // Return null to indicate no change to state.
  }

  componentDidMount() {
    const {IRI, predicat, factory} = this.props;
    if (!this.state.loaded){
      Promise.all([this.loadIndividuals(IRI, predicat, factory)])
        .then(result => {          
          const individuals = [];
          result.map(responseByType => 
            responseByType.map(response => 
              response.bindings.map(item => individuals.push(item.subject.value))
            )
          );
          this.setState({loaded: true, IRI, predicat, individuals});
        })
        .catch( e => {
          this.setState({loaded: true,  IRI, predicat});
          console.log(e);
          message.error("Ошибка загрузки списка объектов.", e);
        })
    }
  }

  loadIndividuals(IRI, predicat, factory){
    let ranges = factory.provider.getRanges(predicat);
    if (Array.isArray(ranges) && ranges.length<1) ranges = ["http://www.w3.org/2002/07/owl#NamedIndividual"];
    const requests = ranges.map(rdfType => AdmsAsset.loadNamedIndividuals(rdfType));
    //console.log("SelectIndividual.js loadIndividuals", ranges);
    return Promise.all(requests) ;
  }

  handleIRIChange = e => {
    const value = e.target.value;
    const iri = (value && (value.startsWith("http://") || value.startsWith("https://")))? value : "http://www.w3.org/ns/adms#"+e.target.value;
    this.setState({iri});
  };

  handleLabelChange = e => {
    e.preventDefault();
    this.triggerChange({text: e.target.value });
  };

  handleOnChange = value => {
    this.triggerChange({ value });
  };

  triggerChange = changedValue => {
    //console.log("SelectIndividual.js triggerChange", changedValue);
    const { onChange, value } = this.props;
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  render() {
    //console.log(this);
    const {IRI } = this.props;
    const {loaded, individuals} = this.state;
    const { getFieldDecorator } = this.props.form;
    return (
      (!loaded? <LoadingComponent />:
        <Form {...formItemLayout} className="ant-edit-form">
          <Form.Item label="Связываемый элемент" extra={IRI}>
            {getFieldDecorator('IRI', {
              rules: [{ required: true, message: 'Пожалуйста, выберите свойство для включения в карточку!' }],
            })(
              <Select
                placeholder="IRI объекта для связи" 
                onChange={this.handleOnChange}>
                {individuals.map((item, key) => (
                  <Option key={key} value={item}><Label iri={item}/> ({item})</Option>
                ))}
            </Select>
            )}
          </Form.Item>
        </Form>
      )
    );
  }
}


export default Form.create({ name: 'select_individual_form' })(SelectIndividualForm);